import { map, camelCase } from "lodash";
import mapKeysDeep from "map-keys-deep-lodash";

import {
  ADD_MODEL,
  REMOVE_MODEL,
  UPDATE_MAX_PRICE_RANGE,
  UPDATE_PRICE_RANGE,
  UPDATE_PAYMENT_TYPE,
  UPDATE_YEAR,
  ADD_TRANSMISSION,
  REMOVE_TRANSMISSION,
  ADD_FUEL_TYPE,
  REMOVE_FUEL_TYPE,
  UPDATE_DEALERS_LOCATIONS,
  UPDATE_REGIONS,
  SORT_BY_PRICE,
  CLEAR
} from "@/store/mutationTypes";
import { getFloorToHundreds, getCeilToHundreds } from "@/utils";
import search from "@/store/modules/search/search";

export default {
  [CLEAR](state) {
    Object.assign(state, search.state);
  },
  [ADD_MODEL](state, model) {
    state.models.push(model);
  },

  [REMOVE_MODEL](state, model) {
    const modelIndex = state.models.indexOf(model);

    state.models.splice(modelIndex, 1);
  },

  [UPDATE_MAX_PRICE_RANGE](state, prices) {
    state.prices.lowest = getFloorToHundreds(prices.min);
    state.prices.highest = getCeilToHundreds(prices.max);
  },

  [UPDATE_PRICE_RANGE](state, prices) {
    const [minPrice, maxPrice] = prices;

    if (state.paymentType === "monthly") {
      state.priceRange.monthly = {
        min: minPrice,
        max: maxPrice
      };
    } else {
      state.priceRange.carPrice = {
        min: minPrice,
        max: maxPrice
      };
    }
  },

  [UPDATE_PAYMENT_TYPE](state, paymentType) {
    state.paymentType = paymentType;
  },

  [UPDATE_YEAR](state, payload) {
    if (payload.type === "minimal") {
      state.year.from = payload.year;
    } else {
      state.year.to = payload.year;
    }
  },

  [ADD_TRANSMISSION](state, transmission) {
    state.transmission.push(transmission);
  },

  [REMOVE_TRANSMISSION](state, transmission) {
    const transmissionIndex = state.transmission.indexOf(transmission);

    state.transmission.splice(transmissionIndex, 1);
  },

  [ADD_FUEL_TYPE](state, fuelType) {
    state.fuelType.push(fuelType);
  },

  [REMOVE_FUEL_TYPE](state, fuelType) {
    const fuelTypeIndex = state.fuelType.indexOf(fuelType);

    state.fuelType.splice(fuelTypeIndex, 1);
  },

  [UPDATE_DEALERS_LOCATIONS](state, dealerLocations) {
    state.dealerLocations = dealerLocations;
  },

  [UPDATE_REGIONS](state, regionsList) {
    state.regionsList = map(regionsList, region =>
      mapKeysDeep(region, (value, key) => camelCase(key))
    );
  },

  [SORT_BY_PRICE](state) {
    state.ordering === "price"
      ? (state.ordering = "-price")
      : (state.ordering = "price");
  }
};
